<template>
  <div style="text-align: center">
    <div style="font-size: 30px;font-weight: bold;margin-top: 50px;margin-bottom: 50px;">Welcome to PlantPP!</div>
    <div>
      <img style="width: 95%;" mode="aspectFit" src="../assets/img/architecture.png" alt />
    </div>
    <div style="font-size: 22px;margin-top: 10px">PlantPP (Plant Phylogenetic Profiling) is designed for gene co-evolution analysis in a wide range of plant species.</div>
    <div style="font-size: 22px;margin-top: 10px">By dissecting co-evolutionary trajectory, this platform aims to 1) predict funtions of less-studied genes and 2)identifying gene co-evolution network.</div>
    <div style="font-size: 22px;margin-top: 10px">Click 'Help' to check how to use.</div>
    <div>
      <el-button style="margin-top: 20px;;margin-bottom: 20px;" type="primary"
        @click="goAnalysis">Start Analysis</el-button>
    </div>
    <div
      style="margin-top: 120px;margin-bottom: 40px;;text-align: center;width: 100%;font-size: 12px;color: grey;">
      <div>Huihui Li Laboratory, Chinese Academy of Agricultural Sciences | 2025 All Rights Reserved.</div>
      <div>Contact us: lihuihui@caas.cn | 12 Zhongguancun South Street, Haidian District, Beijing, China</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
    };
  },
  created() { },
  mounted() {
  },
  methods: {
    goAnalysis() {
      this.$router.push({
        path: `/analyze`,
      })
    }
  }
};
</script>

<style scoped>
::v-deep .el-form-item__label {
  padding: 0px;
  margin-top: 10px;
}
</style>
